<template>
  <div>
    <v-card>
      <div class="pa-3 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="9"> </v-col>
          <v-col
            cols="12"
            md="3"
            class="d-flex"
            :class="$vuetify.breakpoint.smAndDown ? 'mt-1' : ''"
          >
            <div class="mr-2" v-if="$vuetify.breakpoint.smAndDown">
              <v-btn-toggle v-model="toggleBreakpoint" dense>
                <v-btn @click="breakpoint = 0">
                  <v-icon>mdi-view-list</v-icon>
                </v-btn>

                <v-btn @click="breakpoint = 'xs'">
                  <v-icon>mdi-view-grid</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="data"
        item-key="name"
        class="elevation-1 mb-3 historic-bet"
        :search="search"
        :dense="$vuetify.breakpoint.smAndDown"
        :single-select="false"
        :show-select="result == 2"
        :items-per-page="result == 2 ? -1 : 10"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
        :mobile-breakpoint="breakpoint"
      >
        <template v-slot:item.id="{ item }">
          <v-btn @click="$copy(item.id)" x-small>
            {{ item.id }}
          </v-btn>
        </template>
        <template v-slot:item.name_agent="{ item }">
          <p class="mb-0">{{ `Ap .: ${item.punter}` }}</p>
          <p class="mb-0">{{ `Ag .: ${item.name_user}` }}</p>
        </template>

        <template v-slot:item.punter="{ item }">
          <p class="mb-0">{{ `Ap .: ${item.punter}` }}</p>
          <p class="mb-0">{{ `Ag .: ${item.name_user}` }}</p>
        </template>

        <template v-slot:item.date="{ item }">
          {{ item.date }}
        </template>

        <template v-slot:item.events="{ item }">
          <template v-if="!$vuetify.breakpoint.smAndDown">
            <div class="py-2">
              <div
                v-for="(event, index) in item.events"
                :key="index"
                class="caption"
              >
                {{ event.description }} (
                {{ $infoTable.markets(event.id_market).name_market || "" }} -
                {{ $infoTable.outcomes(event.id_outcome).name_outcome || "" }} -
                {{ event.factor_event }}) &nbsp;
                <span
                  class="font-weight-black"
                  v-html="
                    $infoTable.conference(
                      event.result_event,
                      event.status_event
                    )
                  "
                ></span>
                <v-chip
                  class="ml-2 font-weight-black"
                  small
                  color="warning"
                  v-if="legendActiveEvent[event.active_event]"
                >
                  {{ legendActiveEvent[event.active_event] }}
                </v-chip>
              </div>
            </div>
          </template>
          <template v-else>
            {{ item.events.length }}
          </template>
        </template>

        <template v-slot:item.result_bet="{ item }">
          <div
            class="font-weight-black"
            v-html="$infoTable.conference(item.result_bet, item.status_bet)"
          ></div>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn-toggle dense>
            <v-btn
              small
              :title="$t('view')"
              @click="$bet.showBetDialog(item.id, item.printed)"
            >
              <v-icon size="24">mdi-magnify-plus-outline</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card>
    <!-- Resume Perído -->
    <div class="mt-4" v-if="resume.prizeTotal && resume.amountTotal">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-card class="pa-3">
            <div class="subtitle-1 mb-2">
              {{ $t("periodSummary") }}
              <div class="caption">{{ $store.state.rangeUI }}</div>
            </div>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>{{ $t("value") }}</td>
                    <td class="text-right green--text darken-4">
                      {{ resume.amountTotal }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("paidPremiuns") }}</td>
                    <td class="text-right red--text darken-4">
                      {{ resume.prizePaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("passibleAwards") }}</td>
                    <td class="text-right orange--text darken-4">
                      {{ resume.prizeNoPaid || "0.00" }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("totalPrizes") }}</td>
                    <td class="text-right grey--text darken-4">
                      {{ resume.prizeTotal }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "administrator-bet-cancel",

  data: () => ({
    data: [],
    search: "",
    selected: [],
    result: 4,
    tabCancel: false,
    resume: {},
    breakpoint: 0,
    toggleBreakpoint: 0,
  }),
  mounted() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.breakpoint = "xs";
      this.toggleBreakpoint = 1;
    }
  },
  computed: {
    headers() {
      const headers = [
        // ocultos para tratamentos (nao altere)
        { text: "Evento Editado", value: "events_edited", align: " d-none" },
        { text: "Valor_some", value: "amount", align: " d-none" },
        { text: "", value: "punter", align: " d-none" },

        // { text: "Pagar", value: "select", sortable: false, align: " d-none" },
        { text: this.$t("code"), value: "id" },
        { text: this.$t("informations"), value: "name_agent" },
        {
          text: this.$t("events"),
          value: "events",
          width: this.$vuetify.breakpoint.mdAndUp ? 400 : "",
        },
        { text: this.$t("dateTime"), value: "date" },
        { text: this.$t("value"), value: "amount" },
        { text: this.$t("return"), value: "prize" },
        { text: this.$t("result"), value: "result_bet" },
        { text: this.$t("cancelledIn"), value: "date_cancellation" },
        { text: this.$t("actions"), value: "action" },
      ];

      return headers;
    },
    legendActiveEvent() {
      return {
        4: this.$t("canceledList"),
        5: this.$t("deferredList"),
        6: this.$t("canceledList"),
        7: this.$t("canceledList"),
      };
    },

    // ====================================================
    // 2. Retrieve Filters
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    id_agent() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    // ====================================================
    // Retrieve Range:
    rangeDate() {
      return this.$store.state.range.date;
    },
    eventNumber() {
      return this.$store.state.filters.eventNumber.value;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
  },

  watch: {
    saveFilters(val) {
      val && this.requestApi();
    },
  },

  methods: {
    resetPage() {
      this.search = "";
      this.data = [];
    },

    async requestApi() {
      this.resetPage();
      const body = {
        ...this.rangeDate,
        id_regional: this.id_regional || "",
        id_local: this.id_local || "",
        id_agente: this.id_agent || "",
        status: 0,
        resultado: this.result,
        tipo: this.eventNumber,
        export: this.exportDoc,
      };
      let request;
      if (this.exportDoc) {
        const extension = this.exportDoc;
        request = await this.$request.exportDoc(
          "/administrator/bets/list",
          body,
          extension,
          this.rangeDate
        );
      } else {
        request = await this.$request.post("/administrator/bets/list", body);
        this.rowsPerPageItems = request.length;
        this.data = request.length == 0 ? [] : request.dados.apostas;

        // handle Date
        this.data.map(async (item) => {
          item.date = new Date(item.date.replace(" ", "T")).toLocaleString();
          item.date_cancellation = new Date(
            item.date_cancellation.replace(" ", "T")
          ).toLocaleString();
          return item;
        });

        // handle infos
        for (const item of this.data) {
          this.$set(item, "name", item.id);
          let events = "";
          for (const e of item.events) {
            events += `${e.description}
            ${new Date(item.date).toLocaleString()}
            ${this.$infoTable.markets(e.id_market).name_market}
            ${this.$infoTable.outcomes(e.id_outcome).name_outcome}
            ${this.$infoTable.results(item.result_bet)}
            ${this.$infoTable.paid(item.paid)}`;
          }
          this.$set(
            item,
            "size",
            item.events.length >= 4 ? 4 : item.events.length
          );
          this.$set(item, "select", false);
          this.$set(
            item,
            "conference",
            this.$infoTable.results(item.result_bet)
          );
          this.$set(item, "events_edited", events);
        }

        //Build Resume
        this.resume = this.$resume.resumeBet(this.data);
      }
    },
  },
};
</script>
<style>
/* Oculta no mobile 'events_edited' e 'Valor_some' */
.historic-bet.v-data-table tbody td:last-child {
  height: 56px !important;
}
.historic-bet td.v-data-table__mobile-row:nth-child(1),
.historic-bet td.v-data-table__mobile-row:nth-child(2),
.historic-bet td.v-data-table__mobile-row:nth-child(3),
.v-data-table-header-mobile {
  display: none;
}
.historic-bet td.v-data-table__mobile-row:nth-child(4) {
  height: 56px !important;
  font-size: 18px;
}
</style>
